import { render, staticRenderFns } from "./FourOhFour.vue?vue&type=template&id=6cc01552"
import script from "./FourOhFour.vue?vue&type=script&lang=ts"
export * from "./FourOhFour.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports